import * as React from 'react';
import {connect} from 'react-redux';
import {translate} from "react-i18next";
import {compose} from 'redux';
import {RouteComponentProps, withRouter} from 'react-router-dom';
import {IApplicationLink} from 'src/data/IApplicationLink';
import {List} from 'semantic-ui-react';
import {IUserSettings} from '../../data/IUserSettings';
import LeftMenuIcon from './LeftMenuIcon';
import {ITranslatedComponent} from 'src/redux/reducers/generalReducer';
import {IReduxState} from 'src/redux/IReduxState';
import {selectUserSettings} from '../../redux/selectors';

interface IMapStateToProps {
    userSettings: IUserSettings;
}

interface ISlidefromLeft extends RouteComponentProps<any>, IMapStateToProps, ITranslatedComponent { }

interface ISlidefromLeftState {
    isVisible: boolean;
}
class SlidefromLeft extends React.Component<ISlidefromLeft, ISlidefromLeftState> {
    constructor(props: ISlidefromLeft) {
        super(props);
        this.state = {isVisible: false};
    }

    handleSlideFromLeft = () => this.setState(() => ({isVisible: !this.state.isVisible}));

    handleResetSlideFromLeft = (event: React.MouseEvent) => {
        event.stopPropagation();
        this.setState(() => ({isVisible: false}));
    }

    handleLinkDescription = (link: string, t: reactI18Next.TranslationFunction) => {
        const splitBySlash = link.split('/');

        return splitBySlash[0] === 'PSL_LINK' ?
            t(splitBySlash[0]) + ' / ' +
            t(splitBySlash[1].split(':')[0]) + ' ' + splitBySlash[1].split(':')[1] + ' - ' +
            t(splitBySlash[2].split(':')[0]) + ' ' + t(splitBySlash[2].split(':')[1]) + ' - ' +
            t(splitBySlash[3].split(':')[0]) + ' ' + t(splitBySlash[3].split(':')[1]
                .substring(splitBySlash[3].split(':')[1].indexOf('(') + 1, splitBySlash[3].split(':')[1].indexOf(')')))
            :
            t(splitBySlash[0]) + ' ' + splitBySlash[1];
    }

    render() {
        const {isVisible} = this.state;
        const {t, userSettings, history} = this.props;

        const elements =
            userSettings &&
            userSettings.recentWork &&
            userSettings.recentWork.map((link: IApplicationLink) => (
                <List.Item
                    className="custom-slide-left-link"
                    key={link.href}
                    onClick={() => {
                        this.handleSlideFromLeft();
                        history.push(link.href);
                    }}
                    onContextMenu={(event: React.MouseEvent) => {
                        event.preventDefault(); // Prevent the default browser context menu
                        window.open(link.href, '_blank'); // Open the URL in a new tab
                    }}
                >
                    <>
                        <List.Content floated="left">
                            <List.Icon name="arrow right" />
                        </List.Content>
                        {this.handleLinkDescription(link.description, t)}
                    </>
                </List.Item>
            ));

        return (
            <>
                <div
                    className="overlay-left-menu"
                    style={{width: isVisible ? '100%' : '0'}}
                    onClick={this.handleResetSlideFromLeft}
                >
                    <div className="overlay-content">
                        <div className="navlinks">
                            <div className="work-items">
                                <h3 className="list-title"> {t("RECENT_DOCUMENTS")}</h3>
                                <hr className="list-horizontal-line" />
                                {elements && elements}
                            </div>
                        </div>
                    </div>
                </div>
                <LeftMenuIcon
                    handleSlideFromLeft={this.handleSlideFromLeft}
                    isVisible={isVisible}
                    content={!isVisible ? t("RECENT_DOCUMENTS") : t("CLOSE_MENU")}
                />
            </>
        );
    }
}

const mapStateToProps = (state: IReduxState): IMapStateToProps => ({
    userSettings: selectUserSettings(state)
});

export default compose(
    translate(["START_VIEW", "SIDEBAR"]),
    connect<IMapStateToProps>(mapStateToProps),
    withRouter,
)(SlidefromLeft);



// WEBPACK FOOTER //
// ./src/components/NavLink/SlideFromLeft.tsx